<i18n>
{
  "en": {
    "groups": "Groups",
    "productBoostLegend": "The price of the product boost may differ from that shown."
  },
  "es": {
    "groups": "Agrupaciones",
    "productBoostLegend": "El precio del producto promocionado puede diferir al mostrado."
  }
}
</i18n>

<template>
  <dynameat-info-modal>
    <v-container>
      <div class="d-flex justify-space-around body-2 text-center text-md-left">{{ $t('groups') }}</div>
      <legend-group-chips :default-width="150" :group-info="groupList" class="d-flex flex-wrap justify-center"/>
      <div class="mt-5 d-flex justify-center body-2 text-md-left">
        <v-icon color="red" class="mr-2">mdi-rocket-launch</v-icon>
        <span>{{ $t('productBoostLegend')}}</span>
      </div>
    </v-container>
  </dynameat-info-modal>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Components, MapGetters } from '@core/helpers/decorators';
import DynameatInfoModal from '@dynameat/components/DynameatInfoModal';
import LegendGroupChips from '@optimizer/components/LegendGroupChips';

@Component
@Components({ DynameatInfoModal, LegendGroupChips })
@MapGetters(['groupList'])
export default class GroupLegendInfoButton extends Vue {
}
</script>

<style scoped>
.chip {
  min-width: 3em;
  justify-content: center;
}

.v-chip--disabled {
  opacity: 1;
}
</style>
